export const ifSalePurchaseDisclaimer = {
    HEADING: "You are reserving this vehicle for purchase upon grounding.",
    DISCLAIMER: 
        "Seller will confirm availability, mileage and condition. Once confirmed, this item will move to in-process as a new sale. " +  
        "For more information or questions: open a chat, see the event details, or view the terms and conditions.",
    DISCLAIMER_BUY: 
      "This item is listed as an 'If-Sale' purchase. " + 
      "A successful purchase will be moved to 'If' status. " + 
      "These If's are handled in the order received and may take up to 48-hours before action is taken by the seller.",
    DISCLAIMER_OFFER: 
      "This item is listed as an 'If-Sale' purchase. " + 
      "If your offer is accepted, the purchase will be moved to 'If' status. " + 
      "These If's are handled in the order received and may take up to 48-hours before action is taken by the seller.",
    DISCLAIMER_BID: 
      "This item is listed as an 'If-Sale' purchase. " + 
      "If you have the winning bid, the purchase will be moved to 'If' status. " + 
      "These If's are handled in the order received and may take up to 48-hours before action is taken by the seller.",
    DISCLAIMER_ACKNOWLEDGE:
      "I acknowledge the above disclaimer and that this is not a guarantee of purchase."
  }

  export const thirdPartyCrDisclaimer = {
    ACKNOWLEDGE: "I have viewed the",
    LINK_TEXT: "Third Party CR",
  }

  export const offerPromptConsts = {
    ACCEPT: 
      "Click OK to complete your transaction and accept the marketplace terms and conditions.",
    DECLINE:
      "Are you sure you want to decline this offer?",
    REJECT: 
      "Are you sure you want to reject this offer?",
    UPDATE:
      "Click OK to update your offer and to agree to marketplace terms and conditions.",
    WITHDRAW:
      "Are you sure you want to withdraw this offer?",
    COUNTER_ACCEPT:
      "Click OK to complete your transaction and accept the marketplace terms and conditions.",
    COUNTER_DECLINE:
      "Are you sure you want to decline this counter offer?",
  }